<template>
  <Card dis-hover :bordered="true">
    <p slot="title">
      <slot name="title"></slot>
    </p>
    <!-- <a href="#" slot="extra">
      <slot name="extra"></slot>
    </a> -->
    <Row type="flex" align="top" class="code-row">
      <Col
        span="6"
        class="col-box-left"
        type="flex"
        :class="{ 'mid-task': showTaskData.length === 0 }"
        justify="center"
      >
        <div class="col-left" @click="goToTask">
          <count-to
            :end="alltaskData.length"
            count-class="count-style color-orange"
          />
          <div class="tesk-word">
            {{ $t('home.todaytask') }}
          </div>
        </div>
      </Col>
      <Col span="16" class="col-box-rigth" v-show="showTaskData.length > 0">
        <div
          v-for="(item, index) in showTaskData"
          class="task-item"
          :class="{
            'first-task': index === 0,
            'except-first-task': index !== 0,
            'except-last-task': index !== showTaskData.length - 1,
          }"
          :key="index"
        >
          <div cla="item-box">
            <div class="task-name task-content">{{ item.taskName }}</div>
            <div class="task-content">
              <span class="task-detail">{{ item.lastExecutorName }}：</span>
              <span class="task-detail">{{ item.lastExecuteOperation }}</span>
            </div>
          </div>
        </div>
      </Col>
    </Row>
  </Card>
</template>

<script>
import api from '../../../api/home/index';
import { NUMBER_GLOBAL } from '../configParams';
import CountTo from '../../../components/count-to/index';
import moment from 'moment';
export default {
  name: 'task-status-card',
  components: {
    CountTo,
  },
  created() {
    this.getData();
  },
  data() {
    return {
      alltaskData: [],
      showTaskData: [],
    };
  },
  computed: {
    servers() {
      return this.$system.$state.servers;
    },
    baseInfo() {
      return this.$system.$state.baseInfo;
    },
  },
  methods: {
    getData() {
      let nowDay = moment().format('YYYY-MM-DD');
      api
        .getLastMeg({
          startTime: nowDay,
          endTime: nowDay,
          userIds: this.baseInfo.data.id,
          periodType: 1, //1->单天查询，2->一周查询，3->一月查询
          taskType: 2, //任务对象 0发给我的，1我创建的，2全部
          status: 0, //任务状态 0全部，1待办，2过期，3已完成
          //使用任务台历的服务器地址
        })
        .then(res => {
          this.alltaskData =
            res.data && res.data[0] && res.data[0].data
              ? Object.values(res.data[0].data)[0]
              : [];
          this.showTaskData = this.alltaskData.slice(
            0,
            NUMBER_GLOBAL.taskNumber
          );
        })
        .catch(error => {
          console.error(`${error}`);
        });
    },
    goToTask() {
      this.$system.goRouter({
        router: {
          //路由跳转信息,必填
          system: ccconstants.SYSTEM_NOS.Web_Ea, //系统编号，用于辨识该功能模块现在做在哪个系统里面
          url: '/task/view', //跳转路径，需要填写在相应系统里面的路由地址
        },
      });
    },
  },
};
</script>

<style scoped lang="scss" type="text/scss">
.code-row {
  height: 100%;
  .col-left {
    cursor: pointer;
  }
  .col-box-left {
    height: 100%;
    box-sizing: border-box;
    padding: 10px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    div {
      text-align: center;
    }
  }
  .col-box-rigth {
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    .col-right {
      width: 100%;
    }
    .task-item {
      width: 100%;
      height: 64px;
      display: flex;
      align-items: center;
      cursor: pointer;
      flex: 1;
      .task-content {
        padding: 0 10px;
        .task-detail {
          color: #9b9b9b;
        }
      }
      .task-name {
        margin-bottom: 5px;
        font-size: 15px;
        line-height: 1;
      }
    }
  }
  .mid-task {
    margin: 0 auto;
  }
}
.first-task {
  .task-name {
    border-left: 2px solid $secondary-color;
  }
}
.except-first-task {
  .task-name {
    border-left: 2px solid $primary-color;
  }
}
.except-last-task {
  border-bottom: 1px solid #f2f2f2;
}
</style>
